import Vue from 'vue';
import Vuex from 'vuex';

import link from './link.module';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        link
    }
});
